import { render, staticRenderFns } from "./ClicksTable.vue?vue&type=template&id=9369a2b4&"
import script from "./ClicksTable.vue?vue&type=script&lang=js&"
export * from "./ClicksTable.vue?vue&type=script&lang=js&"
import style0 from "./ClicksTable.vue?vue&type=style&index=0&id=9369a2b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports